<template>
  <div>
    <div class="year">{{ year }}</div>
    <div class="month-day">{{ monthDay }}</div>
    <div class="week">{{ week }}</div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: {
    date: Number
  },
  data: function() {
    return {
      year: "108年",
      monthDay: "7月12日",
      week: "週二"
    };
  },
  mounted() {
    const date = dayjs(this.date);
    this.year = `${date.year() - 1911}年`;
    this.monthDay = `${date.month() + 1}月${date.date()}日`;
    const dayOfWeek = ["", "一", "二", "三", "四", "五", "六", "日"];
    this.week = `週${dayOfWeek[date.day()]}`;
  }
};
</script>

<style lang="scss" scoped>
div {
  text-align: center;
  color: #343433;
  font-weight: bold;
}
.year {
  font-size: 18px;
}
.month-day {
  font-size: 18px;
}
.week {
  font-size: 20px;
}

@media (max-width: 1023px) {
  .year,
  .month-day,
  .week {
    font-size: 14px !important;
  }
}
</style>
